// @ts-nocheck
import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useGetPersons from '@hooks/HR/use-get-persons.js';
import useAbsenceType from '@hooks/Lookups/use-Absence-Type.js';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import { AddAbsenceAttendance } from '@store/HR/Person/absenceSlice.js';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import { useEffect } from 'react';
import { GetAbsenceAttendance } from '@store/HR/Person/absenceSlice';
import Loader from '@components/Shared/Loader/Loader';
import { usePermissions } from '@Helper/Permisstions/usePermissions';
import { getPersonId } from '@store/Login/authSelectors';
import Loading from '@components/Shared/Loader/Loading';
import { Card, CardBody, CardHeader } from '@components/card/card.jsx';
import { Alert } from 'react-bootstrap';
import { formAbsenseSchema } from '@pages/ValidationForm/validationSchema.js';

const AddAbsence = ({ personId, isAme = false, setReferenceId }) => {
  const { HasPermission } = usePermissions();
  const { t, i18n } = useTranslation();
  const Navigate = useNavigate();
  const dispatch = useDispatch();

  // ________ جلب البيانات الى الصفحة_____________
  const { Employees } = useGetPersons();
  const personIdFromToken = useSelector(getPersonId);
  const id = isAme === true ? personIdFromToken : personId;
  const { AbsenceAttendanceTypeList, loading, error } = useAbsenceType(id);

  // حالة لإدارة رسالة النجاح
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  // _______________________________________

  const formik = useFormik({
    initialValues: {
      absenceAttendanceTypeId: '',
      personId: personId,
      authorisingPersonId: isAme ? null : '',
      replacementPersonId: '',
      absenceDays: '',
      dateEnd: '',
      dateStart: '',
      comments: '',
      isAme: isAme
    },

    validationSchema: formAbsenseSchema(t),

    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        const response = await dispatch(
          AddAbsenceAttendance({
            absenceAttendanceTypeId: values.absenceAttendanceTypeId,
            personId: isAme ? null : personId,
            authorisingPersonId: values.authorisingPersonId,
            replacementPersonId: values.replacementPersonId,
            absenceDays: values.absenceDays,
            dateEnd: values.dateEnd,
            dateNotification: null,
            dateStart: values.dateStart,
            comments: values.comments,
            isAme: isAme
          })
        );

        if (response?.payload?.succeeded === true) {
          // إظهار رسالة النجاح
          setSuccessMessage(t('AbsenceAddedSuccessfully'));
          setShowSuccess(true);
          CustomAlert({ action: 'Add', msg: t('AbsenceAddedSuccessfully') });

          // إعادة تعيين النموذج
          resetForm();

          // إعادة تحميل البيانات
          if (!isAme) {
            dispatch(GetAbsenceAttendance(personId));
          } else {
            await setReferenceId(response.payload.data);
          }

          // إخفاء رسالة النجاح بعد 3 ثواني
          setTimeout(() => {
            setShowSuccess(false);
            if (onSuccess) onSuccess();
          }, 3000);
        } else {
          CustomAlert({ action: 'Error', msg: response?.payload?.message || t('SaveError') });
        }
      } catch (error) {
        console.error('Save error:', error);
        CustomAlert({ action: 'Error', msg: t('SaveError') });
      } finally {
        setSubmitting(false);
      }
    }
  });

  // ________________ حساب عدد الأيام بناءً على الفرق بين التاريخين____________
  const calculateDateDifference = (from, to) => {
    if (from && to) {
      const date1 = new Date(from);
      const date2 = new Date(to);

      // التأكد من أن تاريخ النهاية بعد تاريخ البداية
      if (date2 < date1) {
        formik.setFieldError('dateEnd', t('EndDateMustBeAfterStartDate'));
        formik.setFieldValue('absenceDays', '');
        return;
      }

      const timeDifference = Math.abs(date2 - date1);
      const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24)) + 1;
      formik.setFieldValue('absenceDays', daysDifference);
      formik.setFieldError('dateEnd', '');
    } else {
      formik.setFieldValue('absenceDays', '');
    }
  };

  const handleDateFromChange = event => {
    const value = event.target.value;
    formik.setFieldValue('dateStart', value);
    calculateDateDifference(value, formik.values.dateEnd);
  };

  const handleDateToChange = event => {
    const value = event.target.value;
    formik.setFieldValue('dateEnd', value);
    calculateDateDifference(formik.values.dateStart, value);
  };

  // إعادة تعيين النموذج عند الإلغاء
  const handleCancel = () => {
    if (formik.dirty) {
      if (window.confirm('هل تريد إلغاء التغييرات؟ سيتم فقدان جميع البيانات المدخلة.')) {
        formik.resetForm();
        if (onCancel) {
          onCancel();
        } else {
          Navigate(-1, { replace: true });
        }
      }
    } else {
      if (onCancel) {
        onCancel();
      } else {
        Navigate(-1, { replace: true });
      }
    }
  };
  //______________________________________________________________________________

  console.log(formik.errors);

  return (
    <>
      {/* رسالة النجاح */}
      {showSuccess && (
        <Alert variant='success' className='d-flex align-items-center mb-4'>
          <i className='fa fa-check-circle fa-lg me-3 text-success'></i>
          <div>
            <h6 className='mb-1'>{t('Success')}</h6>
            <p className='mb-0'>{successMessage}</p>
          </div>
        </Alert>
      )}

      <Loading loading={loading} error={error}>
        <div className='row'>
          <div className='  mx-auto'>
            {/* بطاقة ملخص الطلب */}
            {formik.values.dateStart && formik.values.dateEnd && (
              <Card className='bg-light border-0 mb-4'>
                <CardBody className='py-3'>
                  <div className='row text-center'>
                    <div className='col-4'>
                      <div className='border-end'>
                        <h6 className='mb-1 text-primary'>{formik.values.absenceDays || 0}</h6>
                        <small className='text-muted'>عدد أيام الإجازة</small>
                      </div>
                    </div>
                    <div className='col-4'>
                      <div className='border-end'>
                        <h6 className='mb-1 text-success'>{formik.values.dateStart}</h6>
                        <small className='text-muted'>تاريخ البداية</small>
                      </div>
                    </div>
                    <div className='col-4'>
                      <div>
                        <h6 className='mb-1 text-info'>{formik.values.dateEnd}</h6>
                        <small className='text-muted'>تاريخ النهاية</small>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            )}

            <div className='row mb-4'>
              <div className='col-xl-12'>
                <div className='form-group mb-3'>
                  <label className='form-label required'>
                    {t('Absence_Type')}
                    <small className='text-muted ms-1'>(اختر نوع الإجازة)</small>
                  </label>
                  <Form.Select
                    className='form-select'
                    name='absenceAttendanceTypeId'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.absenceAttendanceTypeId}
                    isInvalid={formik.touched.absenceAttendanceTypeId && formik.errors.absenceAttendanceTypeId}
                  >
                    <option value=''>اختر نوع الإجازة</option>
                    {AbsenceAttendanceTypeList?.map(item => (
                      <option key={item.id} value={item.id}>
                        {i18n.language === 'ar' ? item.name2 : item.name}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type='invalid'>{formik.errors.absenceAttendanceTypeId}</Form.Control.Feedback>
                  <div className='form-text'>اختر نوع الإجازة المناسب من القائمة</div>
                </div>
              </div>
            </div>

            <div className='row mb-4'>
              <div className='col-xl-4'>
                <div className='form-group mb-3'>
                  <label className='form-label required'>
                    {t('Start Date')}
                    <small className='text-muted ms-1'>(تاريخ بداية الإجازة)</small>
                  </label>
                  <Form.Control
                    type='date'
                    className='form-control'
                    name='dateStart'
                    onChange={handleDateFromChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.dateStart}
                    isInvalid={formik.touched.dateStart && formik.errors.dateStart}
                    min={new Date().toISOString().split('T')[0]}
                  />
                  <Form.Control.Feedback type='invalid'>{formik.errors.dateStart}</Form.Control.Feedback>
                  <div className='form-text'>لا يمكن اختيار تاريخ في الماضي</div>
                </div>
              </div>

              <div className='col-xl-4'>
                <div className='form-group mb-3'>
                  <label className='form-label required'>
                    {t('Date_TO')}
                    <small className='text-muted ms-1'>(تاريخ نهاية الإجازة)</small>
                  </label>
                  <Form.Control
                    type='date'
                    className='form-control'
                    name='dateEnd'
                    onChange={handleDateToChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.dateEnd}
                    isInvalid={(formik.touched.dateEnd && formik.errors.dateEnd) || formik.errors.dateEnd}
                    min={formik.values.dateStart || new Date().toISOString().split('T')[0]}
                  />
                  <Form.Control.Feedback type='invalid'>{formik.errors.dateEnd}</Form.Control.Feedback>
                  <div className='form-text'>يجب أن يكون بعد تاريخ البداية</div>
                </div>
              </div>

              <div className='col-xl-4'>
                <div className='form-group mb-3'>
                  <label className='form-label'>
                    {t('Days')}
                    <small className='text-muted ms-1'>(محسوب تلقائياً)</small>
                  </label>
                  <Form.Control
                    className='form-control bg-light border-0 fw-bold text-center fs-5'
                    type='text'
                    autoComplete='off'
                    value={formik.values.absenceDays ? `${formik.values.absenceDays} يوم` : '0 يوم'}
                    readOnly
                    placeholder='0 يوم'
                  />
                  <div className='form-text'>يتم الحساب تلقائياً بناءً على التواريخ</div>
                </div>
              </div>
            </div>

            <div className='row mb-4'>
              {isAme === false && (
                <div className='col-xl-6'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>
                      {t('Authorising_Person')}
                      <small className='text-muted ms-1'>(اختياري)</small>
                    </label>
                    <Select
                      classNamePrefix='react-select'
                      isSearchable={true}
                      name='authorisingPersonId'
                      options={Employees?.map(item => ({
                        value: item.id,
                        label: i18n.language === 'ar' ? item.name2 : item.name
                      }))}
                      onChange={option => formik.setFieldValue('authorisingPersonId', option.value)}
                      onBlur={() => formik.setFieldTouched('authorisingPersonId', true)}
                      placeholder='اختر الشخص المخول'
                      value={
                        Employees?.find(item => item.id === formik.values.authorisingPersonId)
                          ? {
                              value: formik.values.authorisingPersonId,
                              label:
                                i18n.language === 'ar'
                                  ? Employees.find(item => item.id === formik.values.authorisingPersonId)?.name2
                                  : Employees.find(item => item.id === formik.values.authorisingPersonId)?.name
                            }
                          : null
                      }
                    />
                    {formik.errors.authorisingPersonId && formik.touched.authorisingPersonId && (
                      <div className='text-danger small mt-1'>{formik.errors.authorisingPersonId}</div>
                    )}
                    <div className='form-text'>الشخص المسؤول عن الموافقة على الطلب</div>
                  </div>
                </div>
              )}

              <div className={isAme ? 'col-xl-6' : 'col-xl-6'}>
                <div className='form-group mb-3'>
                  <label className='form-label'>
                    {t('replacement')}
                    {/* <small className='text-muted ms-1'>(اختياري)</small> */}
                  </label>
                  <Select
                    classNamePrefix='react-select'
                    isSearchable={true}
                    name='replacementPersonId'
                    options={Employees?.map(item => ({
                      value: item.id,
                      label: i18n.language === 'ar' ? item.name2 : item.name
                    }))}
                    onChange={option => formik.setFieldValue('replacementPersonId', option.value)}
                    onBlur={() => formik.setFieldTouched('replacementPersonId', true)}
                    placeholder='اختر الشخص البديل'
                    value={
                      Employees?.find(item => item.id === formik.values.replacementPersonId)
                        ? {
                            value: formik.values.replacementPersonId,
                            label:
                              i18n.language === 'ar'
                                ? Employees.find(item => item.id === formik.values.replacementPersonId)?.name2
                                : Employees.find(item => item.id === formik.values.replacementPersonId)?.name
                          }
                        : null
                    }
                  />
                  {formik.errors.replacementPersonId && formik.touched.replacementPersonId && (
                    <div className='text-danger small mt-1'>{formik.errors.replacementPersonId}</div>
                  )}
                  <div className='form-text'>الشخص الذي سيقوم بمهامك أثناء الإجازة</div>
                </div>
              </div>

              <div className='col-xl-12'>
                <div className='form-group mb-4'>
                  <label className='form-label'>
                    {t('Notes')}
                    <small className='text-muted ms-1'>({formik.values.comments?.length || 0}/500)</small>
                  </label>
                  <Form.Control
                    className='form-control'
                    as='textarea'
                    rows={3}
                    name='comments'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.comments}
                    placeholder='أدخل أي ملاحظات أو تفاصيل إضافية حول طلب الإجازة...'
                    maxLength={500}
                  />
                  <div className='form-text'>يمكنك إضافة أي ملاحظات أو تفاصيل إضافية</div>
                </div>
              </div>
            </div>

            {/* أزرار التنفيذ */}
            <div className='text-center border-top pt-4'>
              {HasPermission('AddHrPerAbsence') && (
                <button
                  // disabled={formik.isSubmitting || !formik.dirty || !formik.isValid}
                  disabled={formik.isSubmitting}
                  type='button'
                  className='btn btn-theme btn-lg px-5 me-3 rounded-2'
                  onClick={formik.submitForm}
                >
                  {formik.isSubmitting ? (
                    <>
                      <i className='fa fa-spinner fa-spin fa-fw me-2'></i>
                      جاري الحفظ...
                    </>
                  ) : (
                    <>
                      <i className='fa fa-paper-plane fa-fw me-2'></i>
                      {isAme ? 'إرسال طلب الإجازة' : 'تأكيد طلب الإجازة'}
                    </>
                  )}
                </button>
              )}

              <button
                type='button'
                className='btn btn-outline-secondary btn-lg px-5 rounded-2'
                onClick={handleCancel}
                disabled={formik.isSubmitting}
              >
                <i className='fa fa-times fa-fw me-2'></i>
                إلغاء
              </button>
            </div>
          </div>
        </div>
      </Loading>
    </>
  );
};
export default AddAbsence;
